import type Pageable from 'models/Pageable';
import type { InvoicePhaseVO, InvoicePhaseVOModel } from 'models/vo/InvoicePhaseVO';
import { formattingToInvoicePhaseVOModel } from 'models/vo/InvoicePhaseVO';
import http from 'utils/http';
import API_FI from 'utils/http/api/financier';

export async function requestFinancierInvoiceSummaryPhasesList(
  invoiceSummaryId: number,
): Promise<Pageable<InvoicePhaseVOModel[]>> {
  const response = await http.get<Pageable<InvoicePhaseVO[]>>({
    url: API_FI.INVOICE_APPROVAL_PHASES.INVOICE_PHASE_LIST,
    data: {
      pageNumber: 1,
      rowCount: 10,
      invoiceSummaryId: invoiceSummaryId,
    },
  });

  const invoicePhasesData = response.content.map(invoicePhases => formattingToInvoicePhaseVOModel(invoicePhases));

  return {
    ...response,
    content: invoicePhasesData,
  };
}
